import { ClientAssignee } from "@avenueops/shared-types";
import React from "react";
import { Avatar, DropdownMultiSelect } from "@avenueops/web-components";
import { Team } from "@prisma/client";

interface Props {
  userAssignees?: ClientAssignee[];
  teams?: Team[];
  setValue: (_: any) => void;
  value: string[];
}

export default function FilterAssigneeDropdown({ userAssignees, teams, setValue, value }: Props) {
  const options = React.useMemo(() => {
    return [
      {
        label: "Any assignee",
        value: "ALL",
      },
      {
        label: "Unassigned",
        value: "NONE",
      },
      {
        label: "Users",
        options:
          userAssignees?.map((user) => {
            return { label: `${user.firstName} ${user.lastName}`, value: user.id, icon: <Avatar size="SMALL" src={user.image ?? undefined} /> };
          }) ?? [],
      },
      {
        label: "Teams",
        options:
          teams?.map((team) => {
            return { label: team.name, value: team.id, icon: <Avatar size="SMALL" type="EMOJI" src={team.emoji ?? undefined} /> };
          }) ?? [],
      },
    ];
  }, [teams, userAssignees]);

  return userAssignees?.length === 0 ? (
    <div className="text-xs flex flex-col gap-y-1 text-gray-500 text-center px-2">
      <div>We could not find any possible assignees in your organization.</div>
    </div>
  ) : (
    <div className="min-w-[200px]">
      <DropdownMultiSelect
        size="MEDIUM"
        placeholder="Search assignees"
        options={options}
        onChange={(option) => {
          setValue(option);
        }}
        selectedValues={value}
        name={"assignee"}
      />
    </div>
  );
}
